import React from "react";

export const CustomiseContext = React.createContext();